import { FP_PROMO_MAIN_TYPE } from '../shared/promotion-type';
import { safeStorage } from '../shared/safe-storage';

class QuizManager {
    #INITIAL_DATA = { currentSlideIndex: 0, userResponses: [], finished: false, email: '', version: '', expiryTimestampPromo: null, promoType: FP_PROMO_MAIN_TYPE };

    constructor(slides, version, initialSlideIndex) {
        if (!Array.isArray(slides)) {
            throw new Error('Slides must be an array');
        }

        const initialData = initialSlideIndex !== null && initialSlideIndex !== undefined
            ? { ...this.#INITIAL_DATA, version, currentSlideIndex: initialSlideIndex }
            : this.getInitialData(version);

        this.slides = slides;
        this.currentSlideIndex = Math.min(initialData.currentSlideIndex || 0, slides.length - 1);
        this.userResponses = initialData.userResponses;
        this.finished = initialData.finished;
        this.email = initialData.email || '';
        this.version = initialData.version;
        this.expiryTimestampPromo = initialData.expiryTimestampPromo;
        this.promoType = initialData.promoType;
    }

    getInitialData(version) {
        try {
            const results = JSON.parse(safeStorage.getItem('quiz_state'));

            if ((version === undefined || version === results?.version) && results) {
                return results;
            }

            return { ...this.#INITIAL_DATA, version };
        } catch (e) {
            console.error(e);

            return { ...this.#INITIAL_DATA, version };
        }
    }

    getCurrentSlide() {
        return this.slides[this.currentSlideIndex] || null;
    }

    getCurrentSlideIndex() {
        return this.currentSlideIndex;
    }

    submitAnswer(answer) {
        if (this.finished) {
            throw new Error('Quiz is already finished');
        }

        const currentSlide = this.getCurrentSlide();

        if (!currentSlide) {
            throw new Error('No active slide');
        }

        if (answer) {
            if (this.userResponses.find(userResponse => userResponse.questionId === answer.questionId)) {
                this.userResponses = this.userResponses.filter(userResponse => userResponse.questionId !== answer.questionId);
            }

            this.userResponses.push(answer);
        }

        if (this.currentSlideIndex === this.slides.length - 1) {
            this.finished = true;
        } else {
            this.currentSlideIndex += 1;
        }
    }

    nextSlide() {
        if (this.finished) {
            throw new Error('Quiz is already finished');
        }

        const currentSlide = this.getCurrentSlide();

        if (!currentSlide) {
            throw new Error('No active slide');
        }

        if (this.currentSlideIndex === this.slides.length - 1) {
            this.finished = true;
        } else {
            this.currentSlideIndex += 1;
        }
    }

    backSlide() {
        if (this.currentSlideIndex === 0) {
            return undefined;
        }

        const lastUserResponse = this.userResponses.pop();

        this.currentSlideIndex = this.currentSlideIndex - 1;

        return lastUserResponse;
    }

    getResults() {
        return {
            finished: this.finished,
            userResponses: this.userResponses,
            currentSlideIndex: this.currentSlideIndex,
            email: this.email,
            version: this.version,
            expiryTimestampPromo: this.expiryTimestampPromo,
            promoType: this.promoType
        };
    }

    saveState() {
        safeStorage.setItem('quiz_state', JSON.stringify(this.getResults()));
    }

    setEmail(email) {
        this.email = email;
    }

    setExpiryTimestampPromo(expiryTimestampPromo) {
        this.expiryTimestampPromo = expiryTimestampPromo;
    }
}

export {
    QuizManager
};
